import Cookies from 'js-cookie';

import { LOCALES } from 'localization/constants/configEnums';

const LOCALES_CONVERT = {
  en: LOCALES.enUS,
  fr: LOCALES.frFR,
};

export const getLocale = () => {
  const localeFromCookie = Cookies.get('locale');

  return LOCALES_CONVERT?.[localeFromCookie] || LOCALES.enUS;
};
